import createModel, { prop } from 'models/lib/create_model';
import { QuickReplyOption } from 'models/chat_message_quick_reply_option';

export const QuickReplyRequest = createModel({
  modelName: 'QuickReplyRequest',

  properties: {
    options: prop([QuickReplyOption]),
  },
});
